<template>
    <div>
        <h3>アカウント設定</h3>
        <div>
            <p>
                アカウント設定画面で、ユーザー情報を登録することができます。
                ここで適切な設定を行うことで、一部のレーティング作品の閲覧や、小説の投稿が可能になります。
            </p>
            <h4>許可レーティング</h4>
            <p>
                許可レーティングとは、ユーザーが閲覧できるレーティング制限です。
                ここでR18を許可することで、R18作品が表示されるようになります。
                ユーザー登録直後は、R18まで許可された状態になっています。
            </p>
            <p>
                許可レーティングは、<br>
                無し＜R15＜R18＜XXX<br>
                となっており、R18を選択すれば、R15作品も表示されます。
            </p>
            <p>
                許可レーティングをR15に設定して、ご自身でR18作品を書いた場合、
                <b>自分の作品が表示されない</b>という問題が起きるためご注意ください。
            </p>
            <h4>サブドメイン</h4>
            <p>
                ご自身専用の本棚を開設する場合、サブドメインを設定してください。
            </p>
            <p>
                サブドメインはあなたの本棚のサブドメインとなり、あなたの作品が一覧表示されます。
                そのサブドメインの中では、他の作者の作品は表示されません。
                あなただけの本棚です。
            </p>
            <p>
                サブドメインは一意となりますので、既に設定済みのサブドメインは取得できません。
                また、一度取得したサブドメインを途中で変更することは推奨しません。
            </p>
            <p>
                サブドメインには32文字以内の半角英数字、ハイフン(-)のみが使えます。
                アンダースコア(_)は使えないのでご注意ください。
            </p>
            <p>
                サブドメインを設定すると、本棚の名称、自己紹介などを設定することができます。
            </p>
            <h5>サブドメインの変更</h5>
            <img src="/img/help/account/03.png" alt="サブドメインの変更" class="img-thumbnail mb-3">
            <p>
                設定したサブドメインは編集ロックがかかっています。
                サブドメインを変更する場合は、鍵アイコンをクリック（タップ）して、ロックを解除してください。
                ロックを解除した状態で、新たにサブドメインを設定することができます。
            </p>
            <p>
                <b>サブドメインの変更は 5 回まで行えます。</b>
                古いサブドメインは旧サブドメインとして記録され、そのサブドメインにアクセスがあれば、
                新サブドメインへリダイレクトします。
                以前使っていた旧サブドメインへ戻すこともできます。
            </p>
            <p>
                サブドメインの変更を頻繁に行うことは推奨しません。
                頻繁なサブドメイン変更とリダイレクト先の変更は、
                検索エンジンから不穏なサイトと認識される恐れがあります。
            </p>
            <h4>アカウント情報</h4>
            <h5>本棚の名称</h5>
            <p>
                あなたの本棚の名称となります。
                未設定の場合「（作者名）の本棚」と表示されます。
            </p>
            <h5>自己紹介</h5>
            <p>
                本棚のトップに表示されます。未設定の場合は空欄になってしまいますので、記入を推奨します。
            </p>
            <h5>一言の最大件数</h5>
            <p>
                一言コメントの保存件数です（表示件数ではありません）。
                これを超えた一言は、古いものから削除されていきます。
            </p>
            <h5>Blueskyアカウント名</h5>
            <p>
                お持ちのBlueskyアカウント名を登録すると、本棚にリンクが埋め込み表示されます。
            </p>
            <h5>Xアカウント名</h5>
            <p>
                お持ちのXアカウント名を登録すると、本棚にリンクが埋め込み表示されます。
            </p>
            <h5>Google Analytics トラッキングID</h5>
            <p>
                Google Analyticsを登録し、トラッキングIDを設定すると、あなたの本棚へのアクセス解析を行うことができます。
            </p>
            <h5>キーワード</h5>
            <p>
                本棚のキーワードで、metaタグに埋め込まれます。
                半角カンマ区切りで１〜５つ程度指定することを推奨します。
            </p>
            <h5>作者アイコン</h5>
            <p>
                作者のアイコン画像です。<br>
                500 x 500ぐらいの正方形の画像をアップロードできます。
                登録できる形式はjpg、png、gifで、500KBまでに制限されます。
                アイコンは本棚のトップ、ブランド、faviconに使用されます。
            </p>
            <h5>本棚バナー</h5>
            <p>
                本棚トップのバナー画像です。
                幅980px以上、高さ350px以上のサイズを推奨します。3MBまでの画像をアップロードできます。
                バナーを設定しない場合、貸し本棚既定のバナー画像がランダムに表示されます。
            </p>
            <h5>リンクバナー</h5>
            <p>
                伝統的なリンク専用のバナーです。本棚トップページに表示されます。
                幅200px、高さ40pxのサイズを推奨します。500KBまでの画像をアップロードできます。
                リンク集や個人サイトサーチサービスへの登録に使用してください。
                リンク先の仕様に応じて、400px x 80pxの画像も登録できます。
            </p>
            <p class="text-danger">
                バナー画像等には著作権を侵害する画像、公序良俗に反する画像は指定できません。
                この画像はすべての読者に等しく表示されます。
            </p>
            <h4>パスワード・メールアドレス変更</h4>
            <p>
                パスワードログインが設定されているユーザーは、メールアドレスを変更できます。
                メールアドレスを変更した場合、新たに設定されたメールアドレスに確認メールが送信されます。
                承認が行われるまで、メールアドレスは未承認の状態になります。
            </p>
            <p>
                連携ログインのみ設定しているユーザーは、メールアドレスを変更できません。
                先にパスワードログインの設定を行ってからメールアドレスの変更を行ってください。
            </p>
            <p>
                パスワード変更時は、現在設定されているパスワードが必要になります。
                連携ログインのみ設定されているユーザーの場合、現在のパスワードは空欄にしてください。
            </p>
            <h4>メールアドレスを外部サービスと連携する</h4>
            <p>
                パスワードログインが設定されたメールアドレスが、Googleで使用しているものと同一の場合、
                連携ログインを設定することができます。
            </p>
            <p>
                連携ログインボタンを押して、適切なメールアドレスの登録が確認されれば、連携が完了します。
                連携設定していない状態で、連携ログインを行おうとしても、メールアドレスが同一でもログインすることはできません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "アカウント設定 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>